import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogVideoEmbedComponent } from '@cigna/chcp/shared/ui';

@Component({
  selector: 'cigna-evernorth-dialog-evernorth-help-public',
  templateUrl: './dialog-evernorth-help-public.component.html',
  styleUrls: ['./dialog-evernorth-help-public.component.css'],
})
export class DialogEvernorthHelpPublicComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogEvernorthHelpPublicComponent>,
    public dialog: MatDialog,
  ) {}

  close() {
    this.dialogRef.close();
  }

  openHowToRegisterModal() {
    this.dialog.open(DialogVideoEmbedComponent, {
      autoFocus: false,
      width: '900px',
      data: {
        title: 'How to register',
        id: '6f82d46ea8f0476096a7df762d490bb1',
        player: 'limelight',
        width: 800,
        height: 475,
      },
    });
  }
}
